import { Box, Typography, Card, CardContent, Icon } from '@mui/material';

interface PagePlaceholderProps {
  title: string;
  icon?: string;
  phase?: string;
}

/**
 * Componente para paginas que aun no estan implementadas.
 * Muestra titulo + icono + indicacion de en que fase del roadmap esta.
 */
export default function PagePlaceholder({ title, icon = 'construction', phase }: PagePlaceholderProps) {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {title}
      </Typography>

      <Card sx={{ mt: 3 }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 8,
            textAlign: 'center',
          }}
        >
          <Icon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }}>{icon}</Icon>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Pantalla en desarrollo
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
            Esta seccion sera implementada proximamente.
            {phase && (
              <>
                {' '}
                Corresponde a la <strong>{phase}</strong> del roadmap.
              </>
            )}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
